export default "__VITE_ASSET__Jxf9UNOT__"